import { ArrowDownward, ArrowForward, Calculate } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

function FeatureCard({ title, icon, overview, url, availability }) {
    const navigate = useNavigate();

    const scrollToSection = (section) => {
        const element = document.getElementById(section);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Box
            sx={{
                border: '1px #fff solid',
                display: "flex",
                flexDirection: 'column',
                backgroundColor: 'grey.800',
                color: 'grey.200',
                padding: 2,
                borderRadius: 2,
                height: {sm: '230px', md: '200px'}
            }}
            gap={1}
        >
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ display: 'flex', flexGrow: 1 }} gap={1}>
                    {icon}
                    <Typography>{title}</Typography>
                </Box>

                <Chip label={availability === true ? "Available" : "Coming Soon"}
                    sx={{ backgroundColor: availability === true ? "#0f8c08" : "#f5a018", 
                        color: '#f5f3f2', fontSize: '10px', padding: 0}}
                />

            </Box>

            <Typography variant="body2" flexGrow={1} dangerouslySetInnerHTML={{ __html: overview }} />

       <Box
            component="a"
            href={availability ? url : "#footer"}
            target={title === "Blog" ? "_blank" : "_self"}
            rel="noopener noreferrer"
            sx={{
                marginTop: 2,
                fontSize: { xs: '1rem', md: '1.1rem' },
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 0.5,
                textDecoration: 'underline',
            }}
            onClick={(e) => {
                if (!availability) {
                    e.preventDefault();
                    scrollToSection('footer');
                }
            }}
        >
            {availability ? (
                <>
                    Visit <ArrowForward fontSize="small" />
                </>
            ) : (
                <>
                    Join Newsletter <ArrowDownward fontSize="small" />
                </>
            )}
        </Box>


        </Box>
    );
};

export default FeatureCard;